import { render, staticRenderFns } from "./CwcLegoIcon.vue?vue&type=template&id=e8eb7140"
import script from "./CwcLegoIcon.vue?vue&type=script&lang=js"
export * from "./CwcLegoIcon.vue?vue&type=script&lang=js"
import style0 from "./CwcLegoIcon.vue?vue&type=style&index=0&id=e8eb7140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports